"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readStoredPreviewKey = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function storageKey(businessId) {
    return `mango_preview_key_${businessId}`;
}
/**
 * The access code this browser already entered for this business, if any - without prompting.
 * For things that should only appear to someone already let in (e.g. SiteThoughts on every page).
 */
function readStoredPreviewKey(businessId) {
    try {
        return window.localStorage.getItem(storageKey(businessId));
    }
    catch {
        return null;
    }
}
exports.readStoredPreviewKey = readStoredPreviewKey;
function PreviewKeyGate({ apiBaseUrl, businessId, children }) {
    const [previewKey, setPreviewKey] = (0, react_1.useState)(null);
    const [checking, setChecking] = (0, react_1.useState)(true);
    const [input, setInput] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [validating, setValidating] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let stored = null;
        try {
            const params = new URLSearchParams(window.location.search);
            stored = params.get('key') || window.localStorage.getItem(storageKey(businessId));
        }
        catch {
            // localStorage/URL access can throw in some embedded/private contexts - fall through to prompt
        }
        if (!stored) {
            setChecking(false);
            return;
        }
        validate(stored);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [businessId]);
    const validate = async (key) => {
        setValidating(true);
        setError('');
        try {
            const res = await fetch(`${apiBaseUrl}/crm/presentation/${businessId}`, {
                headers: { 'X-Presentation-Key': key },
            });
            if (!res.ok) {
                setError('That key did not work - check it and try again.');
                setPreviewKey(null);
                return;
            }
            try {
                window.localStorage.setItem(storageKey(businessId), key);
            }
            catch {
                // best-effort only
            }
            setPreviewKey(key);
        }
        catch {
            setError('Network error - try again.');
        }
        finally {
            setValidating(false);
            setChecking(false);
        }
    };
    if (checking) {
        return (0, jsx_runtime_1.jsx)("div", { style: { padding: '60px 20px', textAlign: 'center', color: '#888' }, children: "Loading\u2026" });
    }
    if (previewKey) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children(previewKey) });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { style: { maxWidth: 420, margin: '80px auto', padding: '0 20px', textAlign: 'center' }, children: [(0, jsx_runtime_1.jsx)("h2", { style: { marginBottom: 8 }, children: "Enter your access key" }), (0, jsx_runtime_1.jsx)("p", { style: { color: '#888', fontSize: 14, marginBottom: 24 }, children: "Your rep gave you a secret key with this link - enter it below to view this page." }), (0, jsx_runtime_1.jsx)("input", { type: "text", value: input, onChange: (e) => setInput(e.target.value), placeholder: "Access key", style: { width: '100%', padding: '12px 14px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 12 }, onKeyDown: (e) => {
                    if (e.key === 'Enter' && input.trim())
                        validate(input.trim());
                } }), error && (0, jsx_runtime_1.jsx)("div", { style: { color: '#b91c1c', fontSize: 13, marginBottom: 12 }, children: error }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => input.trim() && validate(input.trim()), disabled: validating || !input.trim(), style: {
                    width: '100%', padding: '12px', borderRadius: 8, border: 'none', fontSize: 14, fontWeight: 700,
                    background: validating || !input.trim() ? '#ccc' : '#667eea', color: 'white',
                    cursor: validating || !input.trim() ? 'not-allowed' : 'pointer',
                }, children: validating ? 'Checking…' : 'Continue' })] }));
}
exports.default = PreviewKeyGate;
